/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { textPostTextAesDecrypt } from "../../funcs/textPostTextAesDecrypt.js";
import { PostTextAesDecryptRequest$zodSchema } from "../../models/posttextaesdecryptop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostTextAesDecryptRequest$zodSchema,
};

export const tool$textPostTextAesDecrypt: ToolDefinition<typeof args> = {
  name: "text-post-text-aes-decrypt",
  description: `AES 解密

收到了用AES加密的密文？把它、密钥和随机数（nonce）交给我们，就能还原出原始内容。

## 功能概述
这是一个标准的AES解密接口。你需要提供经过Base64编码的密文、加密时使用的密钥和nonce（随机数，通常为16字节字符串）。

> [!IMPORTANT]
> **关于密钥 \`key\`**
> 我们支持 AES-128, AES-192, 和 AES-256。请确保你提供的密钥 \`key\` 的长度（字节数）正好是 **16**、**24** 或 **32**，以分别对应这三种加密强度。
> 
> **关于随机数 \`nonce\`**
> 通常为16字节字符串，需与加密时一致。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await textPostTextAesDecrypt(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
